import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'services/translation';
import { capitalize } from 'lib/string_utils';

import { BaseSelect } from 'ui_system/forms/BaseSelect';

const { object, array, number, string } = PropTypes;

const handleChange = (selectedOption, props) => {
  const { fieldName, form, bookingId, experienceQuestionId, field, guestId } =
    props;
  const { value } = field;
  form.setFieldValue(fieldName, {
    experienceQuestionId,
    bookingId,
    id: value?.id,
    questionOptionId: selectedOption?.value ?? null,
    guestId,
  });
};

const SelectQuestion = (props) => {
  const { answerOptions, field } = props;
  const { value = {} } = field;
  const selectedOption = answerOptions?.find(
    (option) => option.value === value.questionOptionId
  );
  return (
    <BaseSelect
      value={selectedOption ?? null}
      onChange={(option) => handleChange(option, props)}
      placeholder={capitalize(t('SELECT_ONE'))}
      options={answerOptions}
    />
  );
};

SelectQuestion.propTypes = {
  value: object,
  answerOptions: array.isRequired,
  fieldName: string.isRequired,
  form: object.isRequired,
  bookingId: number,
  experienceQuestionId: number.isRequired,
};

export default SelectQuestion;
